import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { detectarColisoesNumeros } from '../../utils/storage'
import { useAuth } from '../../contexts/AuthContext'

// Banner visível pra admin/gerente quando existe colisão de número entre
// pedidos locais e Bling (ou local↔local). A colisão faz um dos pedidos
// desaparecer da Logística/Kanban por causa da dedup em useOrders. Sem
// este alerta, você só descobria quando cliente reclamava do pedido
// "sumido". Aconteceu 2x antes deste banner (23/07 Rodolfo e caso
// anterior). Re-checa no boot, no mini:resynced (sync com Supabase) e
// a cada 60s pra pegar mudanças de outros dispositivos.
export function ColisaoBanner() {
  const { profile } = useAuth()
  const [colisoes, setColisoes] = useState([])
  const podeVer = profile?.role === 'admin' || profile?.role === 'gerente'

  useEffect(() => {
    if (!podeVer) return
    const check = () => setColisoes(detectarColisoesNumeros())
    check()
    const onSync = () => check()
    window.addEventListener('mini:resynced', onSync)
    const interval = setInterval(check, 60_000)
    return () => {
      window.removeEventListener('mini:resynced', onSync)
      clearInterval(interval)
    }
  }, [podeVer])

  if (!podeVer || colisoes.length === 0) return null

  return (
    <div className="fixed top-14 left-0 right-0 z-50 bg-red-600 text-white text-sm font-medium px-4 py-2 flex items-center justify-between gap-3 shadow-md">
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle size={16} className="shrink-0" />
        <span className="truncate">
          {colisoes.length === 1
            ? `Colisão de número no pedido ${String(colisoes[0].numero).padStart(4, '0')} — pedido pode estar escondido`
            : `${colisoes.length} colisões de número detectadas — pedidos podem estar escondidos`}
        </span>
      </div>
      <NavLink
        to="/diagnostico"
        className="underline whitespace-nowrap hover:text-yellow-200"
      >
        Ver detalhes
      </NavLink>
    </div>
  )
}
